import { h, icons } from '../dom'
import { t } from '../i18n'
import type { WidgetState } from '../state'
import { noteCountLabel } from './toolbar'

export interface ReviewHandlers {
  back: () => void
  send: () => void
}

/** The confirm step: everything the client is about to send, in one list. */
export function renderReview(state: WidgetState, handlers: ReviewHandlers): HTMLElement {
  const studio = state.config?.brand.label
  const body = h('div', { class: 'panel-body' })

  for (const note of state.notes) {
    body.appendChild(
      h(
        'div',
        { class: 'review-item' },
        h(
          'div',
          { class: 'review-head' },
          h('span', { class: 'dot', text: String(note.n) }),
          h('span', { class: 'chip', text: t().typeLabel[note.type] }),
        ),
        h('div', { class: 'review-text', text: note.comment }),
      ),
    )
  }

  const send = h('button', {
    class: 'primary',
    type: 'button',
    text: state.sending ? t().sending : t().sendFeedback,
    onclick: handlers.send,
  }) as HTMLButtonElement
  send.disabled = state.sending

  return h(
    'div',
    { class: 'panel', role: 'dialog', 'aria-label': t().reviewAria },
    h(
      'div',
      { class: 'panel-head' },
      h('div', { class: 'panel-title', text: t().reviewTitle }),
      h('div', {
        class: 'panel-sub',
        text: studio
          ? `${noteCountLabel(state.notes.length)} ${t().reviewFor(studio)}`
          : noteCountLabel(state.notes.length),
      }),
    ),
    h('div', {
      class: 'note-about',
      text: t().snapshotNotice,
    }),
    body,
    h(
      'div',
      { class: 'panel-foot' },
      state.error ? null : null,
      h('button', { class: 'secondary', type: 'button', text: t().back, onclick: handlers.back }),
      send,
    ),
  )
}

export function renderSent(noteCount: number, studio: string | null, onClose: () => void): HTMLElement {
  return h(
    'div',
    { class: 'scrim' },
    h(
      'div',
      { class: 'dialog', role: 'dialog', 'aria-label': t().sentAria },
      h('div', { html: icons.check }),
      h('h2', { text: t().sentTitle }),
      h('p', { text: t().sentBody(noteCount, studio) }),
      h('button', {
        class: 'primary',
        type: 'button',
        text: t().backToSite,
        onclick: onClose,
      }),
    ),
  )
}
